import * as React from "react";
import { FeedItemCommentUser } from "../../../server/feed/buildfeed";
import {
  FeedElementContainer,
  ActionPanel,
} from "../DesignSystem/formatting/FeedComponents";
import { LinkToUser } from "../DesignSystem/LinkToUser";
import { RLink } from "../DesignSystem/RLink";
import { FormattedText } from "../DesignSystem/FormattedText";
import { DateWithTooltip } from "../DesignSystem/DateWithTooltip";

/**
 * A user commenting on another user's profile.
 */
export const FeedElementCommentUser = ({
  item,
}: {
  item: FeedItemCommentUser;
}) => {
  return (
    <FeedElementContainer
      href={`/user/${item.recipient_username}`}
      avatars={[
        { username: item.commenting_username, avatar_url: item.avatar_url },
      ]}
      icon={"comment"}
      title={
        <>
          <LinkToUser linkUser={{ username: item.commenting_username }} />
          <span className="text-slate-500 dark:text-slate-400"> commented on </span>
          <RLink white to={"/user/" + item.recipient_username}>{item.title}</RLink>
        </>
      }
      subtitle={<DateWithTooltip date={new Date(item.created)} />}
      bottom={
        <ActionPanel
          like={{ count: item.comment.likes }}
          reply={{ url: `/user/${item.recipient_username}#comments` }}
        />
      }
    >
      <FormattedText text={item.comment.content} />
    </FeedElementContainer>
  );
};
